export const b2cPolicies = {
  names: {
    signUpSignIn: process.env.REACT_APP_AZURE_AD_B2C_POLICY || '',
  },
  authorities: {
    signUpSignIn: {
      authority: process.env.REACT_APP_AZURE_AD_B2C_SIGN_IN_AUTHORITY || '',
    },
  },
  authorityDomain: process.env.REACT_APP_AZURE_AD_B2C_AUTHORITY_DOMAIN || '',
};

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_AD_B2C_CLIENT_ID || '',
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    navigateToLoginRequestUrl: false,
    redirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};
